import instanciaAxios from './InterceptorAxios';

const servicioSeries = {
	guardar(series) {
		return instanciaAxios.post('/serie/guardar.json',series);
  },
  eliminar(series){
    return instanciaAxios.post('/serie/eliminar.json',series);
  }
}

export default servicioSeries;